import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pet-insurance',
  templateUrl: './pet-insurance.component.html',
  styleUrls: ['./pet-insurance.component.scss']
})
export class PetInsuranceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
